jQuery(function($){

	$(document).ready(function(){
	var currentdate = new Date();
    var datetime = "Now: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/"
                + currentdate.getFullYear() + " @ "
                + currentdate.getHours() + ":"
                + currentdate.getMinutes() + ":"
                + currentdate.getSeconds();

		console.log('ready 2', datetime);

	});

	$('.arSlider').flickity({
	  // options
      autoPlay: true,
      autoPlay: 5000 // {Number}

	});
	$('.main-carousel').flickity({
	  // options
	  cellAlign: 'center',
		wrapAround: true,
		percentPosition: false,
       autoPlay: true,
      autoPlay: 5000 // {Number}
	});

	$('.brand-carousel').flickity({
	contain: true,
       autoPlay: true,
      autoPlay: 5000 // {Number}
	});

	$('.faq_plus').click(function(){
	console.log('clicked');
	})

});

